module.exports = __webpack_public_path__ + "static/img/qqbxc_face.18dfb78.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/qqbxc_face.webp
// module id = hONv
// module chunks = 0